module.exports = __webpack_public_path__ + "static/services-illustration-bec0d81fad2f6a838b71243914b2de96.svg";